import { ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild, HostListener } from '@angular/core';
import { GlobalQuestionService } from '../../services/global-question.service';
import { FlowPageDataPerson, FlowPageDataProduct, FlowProduct, QuoteCollation } from '../../models/quote.model';
import { QuestionFlowSessionQuery } from '../../questions/state/question-flow-session.query';
import { Question } from '../../models/underwriter.model';
import { AnimationOptions } from 'ngx-lottie';
import { EntryType, QuestionType, RouterLinks } from '../../constants';
import { FlowPlayerService } from '../../services/flow-player.service';
import { ActivatedRoute, Router } from '@angular/router';
import { QuestionStore } from '../../questions/state/question.store';
import { QuestionFlowSessionStore } from '../../questions/state/question-flow-session.store';
import { UserStore } from 'src/app/modules/authentication/state/user.store';
import { PolicyQuery } from 'src/app/modules/policy/state/policy.query';
import { Policy } from '../../models/policy.model';
import { PolicyService } from 'src/app/modules/policy/services/policy.service';
import { Subject } from 'rxjs';
import { PausePolicyComponent } from '../policy-actions/pause-resume-policy/pause-policy/pause-policy.component';
import { CancelPolicyComponent } from '../policy-actions/cancel-restore-policy/cancel-policy/cancel-policy.component';
import { ResumePolicyComponent } from '../policy-actions/pause-resume-policy/resume-policy/resume-policy.component';
import { RestorePolicyComponent } from '../policy-actions/cancel-restore-policy/restore-policy/restore-policy.component';
import { Alert, getIndex, scrollToItem, getDescription } from '../../utilities';
import { DatePipe } from '@angular/common';
import { PolicyStore } from 'src/app/modules/policy/state/policy.store';
import { VapService } from '../../services/vap.service';
import { AddonModalComponent } from '../addon-modal/addon-modal.component';


declare const $: any;
declare const accounting: any;
declare function initReadMore(): any;

class EditModalCategories {
  class_id: number;
  class_name: string;
  collations: QuoteCollation[];
}
enum Entity {
  Policy = 'Policy',
  Item = 'Item',
  Vap = 'Vap'
}
@Component({
    selector: 'app-add-benefits',
    templateUrl: './add-benefits.component.html',
    styleUrls: ['./add-benefits.component.scss'],
    standalone: false
})
export class AddBenefitsComponent implements OnInit, OnChanges {


  @ViewChild('addonModalComponent') addonModalComponent: AddonModalComponent;
  sessionDetails: any;
  loading = false;
  loaderOptions: AnimationOptions = {
    path: 'assets/everything-insure-loader.json',
  };

  accounting: any;
  person: any;
  getDescription = getDescription
  question: any;
  frequency_id = 3;
  classes: any = [];
  items: any = [];
  benefits: any = [];
  fees = '';
  selectedItem: any;
  addons: any = [];
  policy: any;
  selectedEntity: any;
  selectedVap: any;
  Entities = Entity;
  count = 0;
  included: any = [];
  vap = {
    name: '',
    description: '',
    price: 0,
    type: '',
    details: []
  }
  benefit: any;
  objectKeys = Object.keys;
  pageData: any;
  collations: any;
  collation_vaps: any;
  product: any;
  constructor(
    public globalQuestionService: GlobalQuestionService,
    private router: Router,
    private policyQuery: PolicyQuery,
    private policyStore: PolicyStore,
    private flowPlayer: FlowPlayerService,
    private ref: ChangeDetectorRef,
    private questionStore: QuestionStore,
    public vapService: VapService,
    private userStore: UserStore,
    private policyService: PolicyService,
    public datePipe: DatePipe,
    private questionFlowSessionStore: QuestionFlowSessionStore,
    private questionFlowSessionQuery: QuestionFlowSessionQuery
  ) {
    this.sessionDetails = this.questionFlowSessionQuery.getValue();
  }

  ngOnInit(): void {

    this.person = this.userStore.getValue();
    this.policy = this.policyQuery.getActive();
    accounting.settings = {
      currency: {
        symbol: this.policy?.currency + ' ' || 'R ', // default currency symbol is '$'
        format: '%s%v', // controls output: %s = symbol, %v = value/number (can be object: see below)
        decimal: '.', // decimal point separator
        thousand: ' ', // thousands separator
        precision: 0, // decimal places
      },
      number: {
        precision: 0, // default precision on numbers is 0
        thousand: ' ',
        decimal: '.',
      }
    };
    this.accounting = accounting;
    console.log(this.policy);
    this.initData();
  }

  ngOnChanges(changes: SimpleChanges): void {


  }
  ngAfterViewInit(): void {


  }
  initData(): void {
    this.questionFlowSessionStore.update({
      session_id: this.policy.session_id,
      state: 'Pending',
      category_id: this.policy.category_id,
      group_id: this.policy.group_id
    });
    const parameters = new Map<string, string>();
    parameters.set('session_id', this.policy.session_id);
    parameters.set('category_id', this.policy.category_id?.toString());
    parameters.set('product_group', this.policy.group_id?.toString());
    parameters.set('product_id', this.policy.product_id ? this.policy.product_id?.toString() : '0');
    this.globalQuestionService.runCommandNew(`calcCollate_addons_2`, parameters)
      .subscribe(x => {
        this.globalQuestionService.spinner(true);
        this.globalQuestionService.getPageData('addons')
          .subscribe(d => {
            
            this.pageData = d;

            this.person = this.globalQuestionService.getIndexData(1, this.pageData)[0];
            this.product = this.globalQuestionService.getIndexData(4, this.pageData)[0];

            this.collation_vaps = this.globalQuestionService.getIndexData(3, this.pageData);
            this.collations = this.globalQuestionService.getIndexData(2, this.pageData);
            this.benefits = this.globalQuestionService.getIndexData(5, this.pageData).filter(x => x?.product_rel.toLowerCase() === 'optional');
            this.included = this.globalQuestionService.getIndexData(5, this.pageData).filter(x => x?.product_rel.toLowerCase() === 'bundle');

            const benefitIds = new Set(this.collation_vaps.map(b => b.product_vaps_id));

            this.benefits = this.benefits.filter(cv => !benefitIds.has(cv.product_vaps_id));

            //this.collation_vaps = this.collation_vaps.filter(x => x?.product_vaps_rel.toLowerCase() !== 'bundle');
            const includedIds = new Set(this.collation_vaps.map(b => b.product_vaps_id && b?.product_vaps_rel.toLowerCase() !== 'bundle'));
            //this.addons = this.collation_vaps.filter(cv => !includedIds.has(cv.product_vaps_id));  
            
            this.getClasses();
            this.globalQuestionService.spinner(false);    
          }, error => {
            this.globalQuestionService.spinner(false);
            $('#error-modal').modal('show');
            $('.error-text').html(error?.error?.Message);
          });
      });
  }
  initTabNav(): void {
    $("#type-nav li a").on("click", function (e) {
      e.preventDefault()
      var $tar = $($(this).attr("href"))

      // nav indicator
      $(this).closest("li").addClass("is-active").siblings("li").removeClass("is-active")

      // switch tab
      $tar.addClass("is-active").siblings(".policy-tabs__tab").removeClass("is-active")
    })
  }

  getClasses(): void {
    this.addons = [];
    this.frequency_id = this.policy?.collation?.find(item => item?.entry_type === EntryType.product_selected)?.frequency_id;

    if (!this.frequency_id) {
      this.frequency_id = 3;
    }

    // Setup fees
    this.fees = '';

    for (let c of this.collations) {

      if (c?.entry_type === EntryType.class_total && c?.frequency_id === this.frequency_id
        && !this.classes?.some(x => x?.class_id === c?.class_id)) {
        this.classes.push(c);
        this.classes.sort((a, b) => a.class_id - b.class_id);
      }


      if (c?.entry_type === EntryType.addon && c?.frequency_id === this.frequency_id
        && !this.addons?.some(x => x?.calc_collation_id === c?.calc_collation_id)) {
        this.addons.push(c);
      }
    }
    


    this.addons = this.addons.map(b => {
      const clone = { ...b }; // shallow copy
      clone.class_name = this.classes.find(x => x?.class_id === b?.class_id)?.description_1;
      return clone;
    });
    this.benefits = this.benefits.map(b => {
      const clone = { ...b }; // shallow copy
      clone.class_name = this.classes.find(x => x?.class_id === b?.class_id)?.description_1;
      return clone;
    });

    // try {
    //   this.addons = this.collation_vaps.reduce((acc, item) => {
    //     const key = `${item.vaps_name}`;
    //     const { vaps_name, class_id, vaps_description, insurer_id, ...rest } = item;
    //     const itemWithClassId = { ...rest, class_id };
    //     if (!acc[key]) {
    //       acc[key] = { vaps_name, class_id, vaps_description, insurer_id, items: [] };
    //     }
    //     acc[key].items.push(itemWithClassId);
    //     acc[key].items.push(rest) ;
    //     return acc;
    //   }, {});
    // }
    // catch { }
    this.included.forEach(v => {
      v.items = this.collation_vaps.filter(cv => cv?.product_vaps_id === v?.product_vaps_id);
    });
    console.log(this.collation_vaps)
    this.addons.forEach(v => {
      v.items = this.collation_vaps.filter(cv => cv?.product_vaps_id === v?.vaps_id);
    });

    // console.log("product", this.product)
    // console.log("addons", this.addons)
    // console.log("inlcuded", this.included)
    // console.log("benefits", this.benefits);
    this.classes.forEach(c => {
      let benefits = this.getBenefits(c.class_id);
      this.count += benefits.length;
    });

    if (this.count === 0) {
      $('#no-benefits-modal').modal('show');
      //Alert("There are no more benefits to add to this policy");
    }
    setTimeout(() => {
      this.initTabNav();
      initReadMore();
    }, 500);
    this.globalQuestionService.spinner(false);

  }

  getClassesWithBenefits() {
    return this.classes.filter(c => this.getBenefits(c?.class_id).length > 0
      || this.included?.some(v => v?.class_id === c?.class_id)
      || this.addons?.some(a => a?.class_id === c?.class_id));
  }
  getClassItems(class_id: number): any {
    return this.items.filter(x => x?.class_id === class_id && x?.mandatory !== 1);
  }
  hasBenefits(id: number): boolean {
    return this.benefits.filter(x => x?.class_id === id);
  }
  getBenefits(id: number): any {
    return this.benefits.filter(x => x?.class_id === id);
  }

  scrollTo(class_id: number): void {
    // Get the element by its ID
    var targetDiv = document.getElementById(class_id.toString());
    // Scroll to the element
    targetDiv.scrollIntoView({ behavior: 'smooth', block: 'start' });

  }
  addBenefit(): void {


  }

  runCalcPremDiff(): void {
    const today = this.datePipe.transform(new Date(), 'yyyy-MM-dd');
    this.policyService.calcPremDiff(this.policy?.session_id, today)
      .subscribe(response => {

        //this.getSummaryOfChanges();
        //this.getPolicy();
      },
        err => {
          this.globalQuestionService.spinner(false);
          const parameters = new Map<string, string>();
          parameters.set('policy_id', this.policy.policy_id.toString());
          parameters.set('person_id', this.person.person_id.toString());
          this.globalQuestionService.runCommandNew(`removePolicyEditVersion`, parameters).subscribe(resp => {
            //this.getPolicy();
          }, error => {
            console.log(error);
          });
        });
  }
  openSidesheet(): void {
    $('#help-sidesheet').addClass('is-active');
  }
  benefitAdded(event: any): void {
    //this.addedItem = event;
    console.log(event);
    this.globalQuestionService.spinner(false);
    $('#addons-modal').modal('hide');
    this.initData();
  }
  backToEditModal(): void {
    let fromPage = localStorage.getItem('previous-document-page');
    this.router.navigate([fromPage], { state: { edit: true, policy_id: this.policy?.policy_id } });
  }
  openAddOnModel(benefit: any, isEdit: boolean = false): void {
    console.log(benefit);
    this.benefit = benefit;
    this.vapService.getVapQuestion(this.benefit?.class_id, this.benefit?.product_vaps_id)
      .subscribe({
        next: (questions: any) => {
          console.log(questions)
          if (questions?.length) {
            this.addonModalComponent.showModal(this.benefit, questions[0], this.policy?.product_id, isEdit);
          }
        }
      });

  }

  openWordingModal(benefit: any, classId: number): void {
    console.log(benefit);
    this.benefit = benefit;
    // for (const vap of this.vaps) {
    //   if (vap.product_vaps_id === vapId && vap.class_id === classId) {
    //     this.selectedVapWording.heading = vap.vaps_name;
    //     this.selectedVapWording.content = vap.body_html;
    //   }
    // }
    $('#see-wording-modal').modal('show');
  }
  setSelectedVap(benefit: any): void {
    this.benefit = benefit;
    console.log(this.benefit);
    setTimeout(() => {
      $('#delete-alert-modal').modal('show');
    }, 500);

  }
  removeVap(): void {
    this, this.globalQuestionService.spinner(true);
    const parameters = new Map<string, string>();
    parameters.set('session_id', this.sessionDetails?.session_id);
    parameters.set('vaps_id', this.benefit?.product_vaps_id?.toString());
    parameters.set('item_id', this.benefit?.session_item_id);
    parameters.set('class_id', this.benefit?.class_id?.toString());

    this.globalQuestionService.runCommandNew('removeBenefit', parameters).subscribe(() => {
      $('#addons-modal').modal('hide');
      $(`.vap_loader_${this.benefit?.product_vaps_id}`).addClass('show');
      $(`.${this.benefit?.product_vaps_id}`).hide();
      this.initData();
      /*this.initData();*/
      //this.getCart();
    });
  }
}
